export default "__VITE_ASSET__dd7f169a__"